import { WeekStats } from "~/hooks/weekStats"
import { ApiUser } from "~/types"

export const filterUsers = (users: ApiUser[], location: string) => {
  return users.filter(
    (user) => location == "" || user.attributes.location == location,
  )
}

export type UserWithStats = ApiUser & {
  week_timers: number
  today_timers: number | null
}

export const usersWithStats = (
  users: ApiUser[],
  stats: WeekStats,
  weekOffset: number,
): UserWithStats[] => {
  const fallbackStats = {
    week_timers: 0,
    today_timers: weekOffset === 0 ? 0 : null,
  }
  return users.map((user) => ({
    ...user,
    ...(stats?.[user.id] || fallbackStats),
  }))
}
